import {Component, ViewChild} from '@angular/core';
import {Events, Nav, Platform} from 'ionic-angular';

import {TranslateService} from '@ngx-translate/core';

import {TabsPage} from '../pages/tabs/tabs';
import {BTInputPage} from '../pages/bt/bt-input/bt-input';
import {MeasureInputPage} from '../pages/measure-input/measure-input';
import {ThemeProvider} from "../providers/theme/theme";

@Component({
  template: `<ion-nav #content [root]="rootPage" [class]="themeProvider.applicationTheme"></ion-nav>`
})

export class MyApp {
  rootPage = TabsPage;

  @ViewChild(Nav) nav: Nav;

  pages: any[] = [
    {title: 'BT Input', component: BTInputPage},
    {title: 'Tabs', component: TabsPage},
    {title: 'Measure Input', component: MeasureInputPage},
  ];

  constructor(private translate: TranslateService,
              public themeProvider: ThemeProvider) {

    this.initTranslate();
  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang('fr');

    if (this.translate.getBrowserLang() !== undefined) {
      this.translate.use(this.translate.getBrowserLang());
    } else {
      this.translate.use('fr'); // Set your language here
    }
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts